"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _systemConstants = require("@telus-uds/system-constants");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function generateResponsiveStyles(min, max) {
  const viewportsArray = _systemConstants.viewports.keys;
  const minIndex = viewportsArray.indexOf(min);
  const maxIndex = viewportsArray.indexOf(max);
  let hiddenViewports = [];
  if (minIndex !== -1) {
    hiddenViewports = viewportsArray.slice(0, minIndex);
  }
  if (maxIndex !== -1) {
    hiddenViewports = hiddenViewports.concat(viewportsArray.slice(maxIndex + 1));
  }
  const styles = {};
  viewportsArray.forEach(viewport => {
    if (hiddenViewports.includes(viewport)) {
      styles[viewport] = {
        display: 'none'
      };
    }
  });
  return (0, _utils.createMediaQueryStyles)(styles, false);
}
const ResponsiveWithMediaQueryStyleSheet = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    min,
    max,
    inheritedStyles = [],
    children
  } = _ref;
  const {
    ids,
    styles
  } = _utils.StyleSheet.create({
    responsive: {
      ...inheritedStyles.reduce((acc, prop) => {
        acc[prop] = 'inherit';
        return acc;
      }, {}),
      ...generateResponsiveStyles(min, max)
    }
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_utils.BaseView, {
    style: styles.responsive,
    dataSet: ids.responsive && {
      media: ids.responsive
    },
    ref: ref,
    children: children
  });
});
ResponsiveWithMediaQueryStyleSheet.displayName = 'Responsive';
ResponsiveWithMediaQueryStyleSheet.propTypes = {
  /**
   * To hide children of `Responsive` if the current viewport is smaller than `min`
   */
  min: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * To hide children of `Responsive` if the current viewport is larger than `max`
   */
  max: _propTypes.default.oneOf(['sm', 'md', 'lg', 'xl']),
  inheritedStyles: _propTypes.default.arrayOf(_propTypes.default.string),
  children: _propTypes.default.node.isRequired
};
var _default = exports.default = ResponsiveWithMediaQueryStyleSheet;